import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';
import { RootState } from 'modules';

export function usePermission() {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  let adminPermission = false;

  if (get(currentUser, 'is_superuser', false) === true) adminPermission = true;

  return { adminPermission };
}
